import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';

import {getTranslations} from '../../selectors/';
import './not-found.less';

function mapStateToProps(state) {
    const translations = getTranslations(state);

    return {
        content: translations['shared.generic404.content'],
        title: translations['shared.generic404.title']
    };
}

@connect(mapStateToProps)
class NotFound extends Component {
    render() {
        const {content, title} = this.props;

        return (
            <Fragment>
                <section className="col-sm-6 col-xs-12 error-code">
                    <h1>{'404'}</h1>
                </section>
                <section className="col-sm-6 col-xs-12 not-found">
                    <h3 className="not-found__title">{title}</h3>
                    <p className="lead">{content}</p>
                </section>
            </Fragment>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/universal/components/not-found/not-found.js